import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ maxWidth: '720px', margin: '0 auto', padding: '2rem' }}>
      <h1>Privacy Policy</h1>
      <p>Last updated: June 21, 2025</p>

      <h2>1. Information We Collect</h2>
      <p>
        We only collect your email address when you choose to provide it for the purpose of communication. No other personal information is collected through this service.
      </p>

      <h2>2. Purpose of Collection</h2>
      <p>
        The collected email address is used solely to contact users regarding service-related inquiries or updates. Your information is not used for marketing or advertising.
      </p>

      <h2>3. Data Sharing</h2>
      <p>
        We do not share your information with any third parties. Your data remains private and is handled with care.
      </p>

      <h2>4. Service Nature</h2>
      <p>
        This service is operated on a non-commercial basis as a personal or experimental project. There is no monetization or data sale associated with this platform.
      </p>

      <h2>5. Contact</h2>
      <p>
        If you have any questions about this policy, please contact us at <a href="mailto:support@akive.net">support@akive.net</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
